import * as React from 'react';
import 'bootstrap';
import 'react-bootstrap';

interface Props {
    wrapper: string;
    title: string;
    className?: string;
    isValidation?: boolean;
    onClick?: () => void;
    style?: object;
    id?: string;
}

class Tooltip extends React.Component<Props, {}> {
    input: HTMLElement;
    // input = React.useRef<HTMLElement>(null);

    componentDidMount(): void {
        this.createTooltip();
    }

    componentDidUpdate(prevProps: Props): void {
        if (this.props.title !== prevProps.title) {
            this.destroyTooltip();
            this.createTooltip();
        }
    }

    componentWillUnmount(): void {
        this.destroyTooltip();
    }

    createTooltip = (): void => {
        const template = '<div class="tooltip tooltip-danger" role="tooltip">'
            + '<div class="arrow"></div><div class="tooltip-inner"></div></div>'; /* tooltip-arrow */
        if (this.props.isValidation) {
            if (this.props.title) {
                $(this.input).tooltip({
                    container: 'body',
                    template: template
                });
            }
        } else {
            $(this.input).tooltip({
                container: 'body'
            });
        }
    }

    destroyTooltip = (): void => {
        // $(this.input).tooltip('destroy'); //'destroy' is not syntax in bootstrap 4.x
        $(this.input).tooltip('dispose');
    }

    handleClick = () => {
        if (this.props.onClick) {
            this.props.onClick();
        }
    }

    render(): JSX.Element {
        // const { wrapper, className, title, children, style, id } = this.props;
        // const Wrapper = React.createElement(wrapper).type;

        const { className, title, children, style, id } = this.props;

        return (
            // <Wrapper
            //     ref={(input: HTMLElement) => { this.input = input; }}
            //     data-toggle="tooltip"
            //     data-placement="top"
            //     title={title}
            //     className={className}
            //     onClick={this.handleClick}
            //     style={style}
            //     id={id}
            // >
            //     {children}
            // </Wrapper>

            <div
                ref={(input: HTMLInputElement) => { this.input = input; }}
                data-toggle="tooltip"
                data-placement="top"
                title={title}
                className={className}
                onClick={this.handleClick}
                style={style}
                id={id}
            >
                {children}
            </div>
        );
    }
}

export default Tooltip;


// WEBPACK FOOTER //
// ./src/components/shared/Tooltip/Tooltip.tsx